import type { ColumnFilters } from './filters';
import { getActiveColumnFilters as getActiveColumnFiltersFor } from 'src/lib/columnFilters/columnFilters';
import type { ActiveColumnFilter as ActiveColumnFilterFor } from 'src/lib/columnFilters/columnFilters';
import { COLUMN_LABELS, DEFAULT_COLUMN_ORDER } from 'src/routes/widgets/LocatesV2Widget/columns';
import type { LocatesV2ColumnId } from 'src/routes/widgets/LocatesV2Widget/columns';

export type ActiveColumnFilter = ActiveColumnFilterFor<LocatesV2ColumnId>;

export function getActiveColumnFilters(filters: ColumnFilters): ActiveColumnFilter[] {
    return getActiveColumnFiltersFor(filters, DEFAULT_COLUMN_ORDER, COLUMN_LABELS);
}
